import { render, staticRenderFns } from "./Parallelograms.vue?vue&type=template&id=d5711ab6&scoped=true"
import script from "./Parallelograms.vue?vue&type=script&lang=ts"
export * from "./Parallelograms.vue?vue&type=script&lang=ts"
import style0 from "./Parallelograms.vue?vue&type=style&index=0&id=d5711ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5711ab6",
  null
  
)

export default component.exports